import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BOOKING_URL, LOGO_URL } from "../mock/mock";

export default function Header({ transparent = false, forceDark = false }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const dark = forceDark || scrolled;
  const bg = dark ? "bg-white/95 backdrop-blur border-b border-black/5" : (transparent ? "bg-transparent" : "bg-white");

  const links = [
    { label: "Home", href: "/" },
    { label: "About", href: "/#about" },
    { label: "Who We Welcome", href: "/#audiences" },
    { label: "Accommodation", href: "/#accommodation" },
    { label: "Gallery", href: "/gallery" },
    { label: "Contact", href: "/#contact" }
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${bg}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 shrink-0">
          <img src={LOGO_URL} alt="Forge Stays" className="h-12 w-12 rounded-full object-cover ring-1 ring-white/20" />
          <div className={`leading-tight ${dark ? "text-forge-navy" : "text-white"}`}>
            <div className="font-serif text-lg tracking-wide whitespace-nowrap">Forge Stays</div>
            <div className="hidden xl:block text-[10px] tracking-[0.25em] uppercase opacity-80 whitespace-nowrap">Escape . Unwind . Return</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          {links.map((l) => (
            l.href.startsWith("/#")
              ? <a key={l.label} href={l.href} className={`whitespace-nowrap ${dark ? "nav-link nav-link-dark" : "nav-link"}`}>{l.label}</a>
              : <Link key={l.label} to={l.href} className={`whitespace-nowrap ${dark ? "nav-link nav-link-dark" : "nav-link"}`}>{l.label}</Link>
          ))}
          <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="btn-gold whitespace-nowrap">Book Now</a>
        </nav>

        <button className={`lg:hidden ${dark ? "text-forge-navy" : "text-white"}`} onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-black/5 px-6 py-4 space-y-3">
          {links.map((l) => (
            l.href.startsWith("/#")
              ? <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="block nav-link nav-link-dark py-2">{l.label}</a>
              : <Link key={l.label} to={l.href} onClick={() => setOpen(false)} className="block nav-link nav-link-dark py-2">{l.label}</Link>
          ))}
          <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="btn-gold w-full">Book Now</a>
        </div>
      )}
    </header>
  );
}
